import React, {useEffect, useState} from "react";
import {DentobookApplicationContext} from "../../context/DentobookApplicationContext";
import {bitwiseOr, isAccessibleFor, isNotAccessibleFor} from "../../utils/accessUtils";

interface AccessControlProps {
    children?: any;
    accessibleFor?: number[];
    notAccessibleFor?: number[];
}

const AccessControl = (props: AccessControlProps) => {

    const { principal } = React.useContext(DentobookApplicationContext);

    const [accessible, setAccessible] = useState(false);

    useEffect(() => {
        if(props.accessibleFor) {
            setAccessible(isAccessibleFor(principal?.user, bitwiseOr(props.accessibleFor)));
        } else if (props.notAccessibleFor) {
            setAccessible(isNotAccessibleFor(principal?.user, bitwiseOr(props.notAccessibleFor)));
        }
    }, [principal]);

    return (
        <>
            { accessible &&
                <>{props.children}</>
            }
        </>
    )
}

export default AccessControl
